import React, { useEffect, useState } from 'react'
import GetExpense from '../../../APIs/Master/Expense/GetExpense';
import GetUnitMaster from '../../../APIs/Master/UnitMaster/GetUnitMaster';
import GetVendorDetails from '../../../APIs/AddVendor/GetVendorDetails';
import GetItemMaster from '../../../APIs/ItemMaster/GetItemMaster';
import InsertPurchaseOrder from '../../../APIs/Vendor/InsertPurchaseOrder';
import UpdatePurchaseOrder from '../../../APIs/Vendor/UpdatePurchaseOrder';
import SideMessage from '../../../components/SideMessage';
import Loader from '../../../components/Loader';
import GetPurchaseOrder from '../../../APIs/Vendor/GetPurchaseOrder';
import { useParams } from 'react-router-dom';

export default function AddPurchaseOrder(props) {
    let [expenseList, setExpenseList] = useState([]);
    let [unitList, setUnitList] = useState([])
    let [itemList, setItemList] = useState([])
    let [vendorList, setVendorList] = useState([])
    let [sendForm, setSendForm] = useState({
        expenseTypeId: 0,
        vendorId: 0,
        itemId: 0,
        quantity: 0,
        unitId: 0,
        price: 0,
        userId: window.userId
    })
    const { id } = useParams();
    const [isShowLoader, setIsShowLoader] = useState(0)
    const [sideToster, setSideToster] = useState({
        show: 0,
        message: '',
        type: ''
    })

    const getPurchaseOrder = async (id) => {
        try {
            setIsShowLoader(1);
            let purchaseorder = await GetPurchaseOrder(id)
            if (purchaseorder.status === 1) {
                setSendForm(purchaseorder?.responseValue[0])
                setIsShowLoader(0);
            }
            else {
                setSideToster({
                    message: purchaseorder.responseValue,
                    show: 1,
                    type: 'alert'
                })
                setIsShowLoader(0);
            }
        }
        catch (e) {
            setSideToster({
                message: e.message,
                show: 1,
                type: 'alert'
            })
            setIsShowLoader(0);
        }

    }
    let getAllExpenses = async () => {
        const response = await GetExpense();
        if (response.status === 1) {
            setExpenseList(response.responseValue);
        }
    };
    let getUnitMaster = async () => {
        const units = await GetUnitMaster()
        if (units.status === 1) {
            setUnitList(units.responseValue)
        }
    };
    let getVendor = async () => {
        let vendor = await GetVendorDetails()
        if (vendor.status === 1) {
            setVendorList(vendor.responseValue)
        }
    };
    let getItemMaster = async () => {
        let item = await GetItemMaster()
        if (item.status === 1) {
            setItemList(item.responseValue)
        }
    };



    let handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value
        setSendForm({ ...sendForm, [name]: value })
    }

    const validateSendForm = (form) => {
        let errors = "";

        if (!form.expenseTypeId || form.expenseTypeId === 0) {
            errors = "Expense Type is required";
            return errors;
        }

        if (!form.vendorId || form.vendorId === 0) {
            errors = "Vendor is required";
            return errors;
        }

        if (!form.itemId || form.itemId === 0) {
            errors = "Item is required";
            return errors;
        }

        if (!form.quantity || form.quantity <= 0) {
            errors = "Quantity must be greater than 0";
            return errors;
        }

        if (!form.unitId || form.unitId === 0) {
            errors = "Unit is required";
            return errors;
        }

        if (!form.price || form.price <= 0) {
            errors = "Price must be greater than 0";
            return errors;
        }

        if (!form.userId) {
            errors = "User not found";
            return errors;
        }
        return errors;

    };
    const handleSaveForm = async () => {
        try {
            const error = validateSendForm(sendForm);
            if (error.length > 0) {
                setSideToster({
                    message: error,
                    show: 1,
                    type: 'Alert'
                });
                return;
            }
            setIsShowLoader(1);
            const response = await InsertPurchaseOrder(sendForm);
            if (response.status === 1) {
                setIsShowLoader(0);
                setSideToster({
                    message: 'Data Save',
                    show: 1,
                    type: 'Success'
                })
                setTimeout(() => {
                    props.closeModal(0);
                }, 600)
            }
            else {
                setIsShowLoader(0);
                setSideToster({
                    message: response?.responseValue,
                    show: 1,
                    type: 'Alert'
                })
            }
        }
        catch (e) {
            setIsShowLoader(0);
            setSideToster({
                message: e.message,
                show: 1,
                type: 'Alert'
            })
        }
    }
    const handleUpdate = async () => {
        try {
            const error = validateSendForm(sendForm);
            if (error.length > 0) {
                setSideToster({
                    message: error,
                    show: 1,
                    type: 'Alert'
                });
                return;
            }
            setIsShowLoader(1);
            const response = await UpdatePurchaseOrder(sendForm);
            if (response.status === 1) {
                setIsShowLoader(0);
                setSideToster({
                    message: 'Data Update',
                    show: 1,
                    type: 'Success'
                })
                props.setEditData({});
                props.setIsEdit(0);
                setTimeout(() => {
                    props.closeModal(0);
                }, 600)
            }
            else {
                setIsShowLoader(0);
                setSideToster({
                    message: response?.responseValue,
                    show: 1,
                    type: 'Alert'
                })
            }
        }
        catch (e) {
            setIsShowLoader(0);
            setSideToster({
                message: e.message,
                show: 1,
                type: 'Alert'
            })
        }
    }

    useEffect(() => {
        if (id) {
            getPurchaseOrder(id)

        }
    }, [id])
    useEffect(() => {
        getAllExpenses();
        getUnitMaster();
        getVendor();
        getItemMaster();
    }, [])
    return (
        <div className='container-fluid landformconatiner p-4' >
            <h1 className="modal-title fs-5 text-primary" id="addexpensesLabel">Add Purchase Order</h1>
            <div className='wrapform'>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Expenses Type</label>
                            <select className='form-input-box form-select pe-5' name='expenseTypeId' value={sendForm.expenseTypeId} onChange={handleChange} >
                                <option value="-1">--Select Expenses Type--</option>
                                {
                                    expenseList && expenseList.map((val, ind) => {
                                        return (
                                            <option value={val.id}>
                                                {val.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Vendor</label>
                            <select className='form-input-box form-select pe-5' name='vendorId' value={sendForm.vendorId} onChange={handleChange} >
                                <option value="-1">--Select Vendor --</option>
                                {/* <option value="0">No Vendor</option> */}
                                {
                                    vendorList && vendorList.map((val, ind) => {
                                        return (
                                            <option value={val.id}>
                                                {val.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Item Name</label>
                            <select className='form-input-box form-select pe-5' name='itemId' value={sendForm.itemId} onChange={handleChange} >
                                <option value="-1">--Select Item--</option>
                                {
                                    itemList && itemList.map((val, ind) => {
                                        return (
                                            <option value={val.id}>
                                                {val.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col-4 pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Quantity</label>
                            <input type='number' name="quantity" className='form-input-box' id="quantity" onChange={handleChange} value={sendForm.quantity} />
                        </div>
                    </div>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Unit</label>
                            <select className='form-input-box form-select pe-5' name='unitId' value={sendForm.unitId} onChange={handleChange} >
                                <option value="-1">--Select Unit--</option>
                                {
                                    unitList && unitList.map((val, ind) => {
                                        return (
                                            <option value={val.id}>{val.name}</option>
                                        )
                                    })
                                }

                            </select>
                        </div>
                    </div>
                </div>
                <div className='row pb-4'>
                    <div className='col pb-2 pb-md-0'>
                        <div className='d-flex flex-column gap-1'>
                            <label className='form-label'>Price</label>
                            <input type='number' name="price" className='form-input-box' id="price" onChange={handleChange} value={sendForm.price} />
                        </div>
                    </div>
                </div>
            </div>

            <div className='d-flex flex-row justify-content-md-end'>
                {
                    !props.isEdit ?

                        <button className="btn export-save-btn" onClick={handleSaveForm}>Add Purchase Order</button>
                        :
                        <button className="btn export-save-btn" onClick={handleUpdate}>Update Purchase Order</button>

                }
            </div>
            {
                sideToster.show === 1 ?
                    <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
                    : ""
            }
            {
                <Loader show={isShowLoader} />
            }
        </div>
    )
}
